/**
 * 服务端请求相关处理
 */
import { getAbsPath, joinActionIdToDoUrl } from './utils';
import request from '../utils/request';
/**
 * @method getPageMeta
 * @description 获取emap pageMeta数据
 * @param  {String} pagePath - 页面地址
 * @param  {Object} params - 请求参数
 * @param  {Object} requestOption - 请求配置
 * @return {Object} pageMeta
 */

export const getPageMeta = async (pagePath, params) => {
  const queryParams = Object.assign({
    '*json': '1'
  }, params);
  const pageMeta = await request({
    url: getAbsPath(pagePath),
    query: queryParams
  }); // window._EMAP_PageMeta = window._EMAP_PageMeta || {}
  // window._EMAP_PageMeta[pagePath] = pageMeta
  // if (typeof pageMeta.loginURL !== 'undefined') {
  //   window._EMAP_PageMeta = {}
  // }

  return pageMeta;
};
/**
 * @method getModel
 * @description 获取emap模型
 * @param  {String} pagePath -  页面地址
 * @param  {String} actionId - 动作名称
 * @param  {String} type - 请求模型的类型，可选值 form grid search
 * @param  {Object} [params] - 请求参数
 * @param  {String} [requestOption] - 请求配置
 * @example
 *   const formModel = getModel('modules/editForm.do', 'T_PXXX_XSJBXX_QUERY', 'form')
 */

export const getModel = async ({
  pagePath,
  actionId,
  type,
  params
} = {}) => {
  if (typeof pagePath === 'object') {
    return convertModel(pagePath, type);
  }

  let pageMeta = await getPageMeta(pagePath, params);
  let model;

  if (type === 'search') {
    let url = getAbsPath(pagePath);
    url = joinActionIdToDoUrl(url, actionId);
    pageMeta = await request({
      url,
      query: Object.assign({
        '*searchMeta': '1'
      }, params)
    });
    model = pageMeta.searchMeta;
  } else {
    model = null;

    if (pageMeta.models && pageMeta.models.length) {
      const models = pageMeta.models.filter(function (val) {
        return val.name === actionId;
      });
      model = models[0];
    }
  } // WIS_EMAP_SERV.modelName = model.modelName
  // WIS_EMAP_SERV.appName = model.appName
  // WIS_EMAP_SERV.url = model.url
  // WIS_EMAP_SERV.name = model.name
  // return convertModel(model, type)


  return model;
};
export const getData = async (pagePath, actionID, queryKey, beforeSend) => {
  // window._EMAP_PageMeta = window._EMAP_PageMeta || {}
  // let pageMeta = window._EMAP_PageMeta[pagePath]
  // if (pageMeta === undefined) {
  //   pageMeta = await getPageMeta(pagePath)
  // }
  // const model = pageMeta.models.filter(function (val) {
  //   return val.name === actionID
  // })
  // const modelPath = pagePath.substring(0, pagePath.indexOf('/')) + '/' + model[0].url
  let result = await request({
    url: pagePath,
    query: queryKey,
    beforeSend
  });

  if (result === undefined || result == null) {
    result = {
      code: 0,
      // msg: $.i18n('bh-sv-noDatas'),
      datas: {}
    };
    return {
      rows: []
    };
  } else {
    if (result.result !== undefined && result.result.datas !== undefined) {
      result = result.result;
    }

    return result.datas[actionID];
  }
};
/**
 * @method convertModel
 * @description 转换模型，给模型字段项加上get方法
 * @param {Object} model - 数据模型
 * @param {String} [type] - 类型 可选值  'form' 'grid' 'search'
 */

export const convertModel = function (model, type) {
  if (model === undefined || model === null) {
    // getData = {code: 0,msg: '没有数据',models:[],datas:{}}
    return undefined;
  } else {
    if (type === undefined) {
      return model.controls; // return BH_UTILS.i18nObject(model.controls)
    } else {
      if (model instanceof Array) {
        // BH_UTILS.i18nObject(model)
        // addGetMethod(model)
        return model;
      } else {
        // BH_UTILS.i18nObject(model.controls)
        // addGetMethod(model.controls)
        if (type === 'search') {
          return model;
        }

        return model.controls;
      }
    }
  } // function addGetMethod (modelArray) {
  //   modelArray.map(function (item) {
  //     item.get = function (field) {
  //       if (this[type + '.' + field] !== undefined && this[type + '.' + field] !== '') {
  //         return this[type + '.' + field]
  //       }
  //       return this[field]
  //     }
  //     // add from 研究生-马平 如果jsonparam 是对象，则将其格式化 by jbxu 2019-04-16
  //     if (item.JSONParam && Object.prototype.toString.call(item.JSONParam) === '[object Object]') {
  //       item.JSONParam = JSON.stringify(item.JSONParam)
  //     }
  //   })
  // }

};